import { configureStore } from '@reduxjs/toolkit';
import CONST from "../config/CONST";
import createStorageMiddleware, {getStorageState} from 'redux-simple-storage-middleware';

import appReducer from './slices/appSlice';
import userConfigurationsReducer from './slices/userConfigurationsSlice';
import financialConfigurationsReducer from "./slices/financialConfigurationsSlice";

const browserStorageMiddleware = createStorageMiddleware({
    key: CONST.BROWSER_STORAGE_KEY,
    type: CONST.BROWSER_STORAGE_TYPE,
    exclude: [ 'app', 'financialConfigurations' ]
});

const storageState = getStorageState({
    key: CONST.BROWSER_STORAGE_KEY,
    type: CONST.BROWSER_STORAGE_TYPE
});

export default configureStore({
    reducer: {
        app: appReducer,
        userConfigurations: userConfigurationsReducer,
        financialConfigurations: financialConfigurationsReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(browserStorageMiddleware),
    preloadedState: storageState
});
